import { combineReducers, configureStore } from '@reduxjs/toolkit';

import { baseApi } from './api/baseApi';
import { errorLoggerMiddleware } from './middleware/errorLogger';
import { negotiationConflictHandler } from './middleware/negotiationConflictHandler';
import commonReducer from './slices/commonSlice';
import transactionsReducer from './slices/transactionsSlice';
import userReducer from './slices/userSlice';

const rootReducer = combineReducers({
  common: commonReducer,
  user: userReducer,
  transactions: transactionsReducer,
  [baseApi.reducerPath]: baseApi.reducer,
});

export const setupStore = (preloadedState?: Partial<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(
        baseApi.middleware,
        errorLoggerMiddleware,
        negotiationConflictHandler
      ),
    preloadedState,
  });
};

export const store = setupStore();

export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export type AppStore = typeof store;
